import React, { PureComponent } from 'react';
import classnames from 'classnames';

import { is1024Query } from '~/core/scripts/mediaquery-helper';
import Icon from '~/core/scripts/components/Icon';
import Utils from '~/core/scripts/utils';

import './tooltip.styl';

class Tooltip extends PureComponent {

  onClose(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    this.props.onClose();
  }

  render() {
    // const TOOLTIP_WIDTH = 220;
    const { data, pos, isVisible, tooltipAbsLabel, icon, decimals, unit } = this.props;
    const style = is1024Query() ? { left: `${pos.x + 15}px`, top: `${pos.y - 75}px` } : {};
    // const isInverted = pos.x + 35 + TOOLTIP_WIDTH >= window.innerWidth;
    const tooltipClass = classnames('tooltip-wrapper', { 'is-active': isVisible, invert: true });

    if (!data) {
      return null;
    }

    const currValue = data.value;
    const title = data.title;
    const subtitle = data.subtitle;
    const info = data.info;
    return (
      <div className={tooltipClass} style={{ ...style, borderColor: data.color }}>
        <div className="tooltip">
          <button className="btn close" onClick={evt => this.onClose(evt)}>
            <Icon type="close" />
          </button>
          <div className="tooltip-header">
            <div className="tooltip-title">{title}</div>
            <div className="tooltip-subtitle">{subtitle}</div>
          </div>
          {!Utils.isNumeric(currValue) ?
            <div className="tooltip-body">
              <div className="tooltip-nodata">{info}</div>
            </div> :
            <div className="tooltip-body">
             <div className="tooltip-body-left">
                <div className="tooltip-value">
                  <Icon type={icon} />
                  <div>{Utils.numberFormat(currValue, decimals)} {unit}</div>
                </div>
                {tooltipAbsLabel && (
                  <div className="tooltip-label">
                    {Utils.numberFormat(data.valueAbs)} {tooltipAbsLabel}
                  </div>
                )}
              </div>
              <div className="tooltip-body-right">
                <div className="tooltip-value">
                  <div>{Utils.numberFormat(data.valueGreen, 1)} %</div>
                </div>
                <div className="tooltip-label">
                  Grünen-Wähler
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
};

export default Tooltip;
